export default __webpack_public_path__ + "static/media/ImagemTrechoPadrao.9e2f3a13.webp";